import { Button, IconButton, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import CloseIcon from '@mui/icons-material/Close';
import { useFormContext } from '../../contexts/FormContext';
import { useFormData } from '../../hooks/useFormValues';
import { compare_array_dates } from '../../utils/utils';
import FieldRenderer from './FieldRenderer';
import type { FieldSchema } from './types';

const ListField = ({ field }: { field: FieldSchema }) => {
  const { getFormDataItem, handleChange } = useFormContext();
  const formData = useFormData();
  const isDisabled = field.hasOwnProperty('disabled') ? getFormDataItem(formData, field.disabled as string) : false;

  const draftName = (subName: string) => `${field.name}__draft__${subName}`;

  return (
    <Grid size={field.size || 12} sx={{ mb: 2 }}>
      <Grid container spacing={2}>
        {field?.fields?.map((subField, index) => (
          <FieldRenderer key={subField.name || index} field={{ ...subField, name: draftName(String(subField.name)) }} />
        ))}
        <Grid>
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              onClick={() => {
                let val;
                let new_element: Record<string, any> = {};
                field.fields?.forEach((f: any) => {
                  new_element[f.name] = getFormDataItem(formData, draftName(f.name));
                });
                val = [new_element];
                if (getFormDataItem(formData, field.name!)) {
                  val = getFormDataItem(formData, field.name!);
                  val.push(new_element);
                }
                return handleChange({ target: { name: field.name, value: val, type: field.type, checked: false } }, field);
              }}
              disabled={isDisabled}
            >
              Add
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                handleChange({ target: { name: field.name, value: [], type: field.type, checked: false } }, field);
              }}
              disabled={isDisabled}
            >
              Clear
            </Button>
          </Stack>
        </Grid>
      </Grid>
      {getFormDataItem(formData, field.name!)?.length ? (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <ul style={{ listStyle: 'none', padding: 0, width: '100%' }}>
            {getFormDataItem(formData, field.name!)
              ?.sort(compare_array_dates)
              .map((item: any, index: number) => {
                return Object.keys(item).map((key) => {
                  let d = new Date(item[key]);
                  return (
                    <li
                      key={`${index}-${key}`}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '8px 0',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                      }}
                    >
                      <Typography color="text.primary">
                        {key}:{' '}
                        {field?.fields?.[0]?.format?.includes('YYYY')
                          ? d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2)
                          : d.getDate() + '/' + ('0' + (d.getMonth() + 1)).slice(-2)}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          let val = getFormDataItem(formData, field.name!);
                          val.splice(index, 1);
                          return handleChange({ target: { name: field.name, value: val, type: field.type, checked: false } }, field);
                        }}
                        sx={{
                          color: 'error.main',
                          '&:hover': {
                            backgroundColor: 'error.light',
                            color: 'error.contrastText',
                          },
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </li>
                  );
                });
              })}
          </ul>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default ListField;
